/* ==========================================================================
   CAIXA FILOSOFAL - comportamento de secao

   Portado de prototipo/app.js. O que NAO veio junto, e por que:

     - seletor de tema: era ferramenta de apresentacao, para o grupo escolher a
       dominancia de cor ao vivo. A cor foi decidida; o seletor perdeu a funcao.
     - acordeao do FAQ: virou <details>/<summary> nativo, que funciona sem JS.
     - contador ilustrativo de orcamento: agora existe carrinho de verdade,
       tratado em pedido.js.

   Tudo aqui respeita prefers-reduced-motion.
   ========================================================================== */

(function () {
  'use strict';

  var paraMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- personalizador de cor ----------
     Desde 28/08 nao sao mais fotos: sao quadros montados em camadas (ver
     snippets/quadro-vivo.liquid). Ficam empilhados no mesmo lugar e so o ativo
     aparece, mesma mecanica de antes.

     O seletor aceita as duas coisas de proposito. A secao ja passou por moldura
     em CSS, foto e quadro montado em dois dias; se um dia voltar a ter foto
     misturada com quadro, o rodizio continua funcionando. */

  function iniciarAmostras() {
    var palco = document.querySelector('[data-personalizador]');
    if (!palco) return;

    var amostras = palco.querySelectorAll('.amostra');
    var fotos = palco.querySelectorAll('.person__foto, .person__fotos .quadro');
    if (!amostras.length) return;

    var nome = document.querySelector('[data-cor-nome]');

    function seleciona(i) {
      Array.prototype.forEach.call(amostras, function (outra, k) {
        outra.setAttribute('aria-pressed', k === i ? 'true' : 'false');
      });
      Array.prototype.forEach.call(fotos, function (foto, k) {
        foto.classList.toggle('esta-ativa', k === i);
      });
      if (nome && amostras[i]) nome.textContent = amostras[i].dataset.nome;
    }

    /* ---------- o rodizio ----------
       As cores passam sozinhas, em laco, para a secao ter movimento proprio: e
       o que mostra que a foto muda sem depender de a pessoa descobrir que da
       para clicar. No primeiro clique o rodizio PARA e nao volta — dali em
       diante quem manda e a escolha dela, e uma foto trocando sozinha embaixo
       do dedo seria briga, nao demonstracao.

       Fora da tela ele nao roda: animacao infinita em secao que ninguem esta
       vendo gasta bateria e disputa a thread de composicao com a rolagem. */
    var atual = 0;
    var relogio = null;
    /* Com uma cor so nao ha rodizio: (0+1)%1 e sempre 0, e o laco ficaria
       reescrevendo o mesmo estado para sempre, sem nada mudar na tela. */
    var parado = paraMovimento || amostras.length < 2;

    function proxima() {
      atual = (atual + 1) % amostras.length;
      seleciona(atual);
    }

    function liga() {
      if (parado || relogio) return;
      relogio = setInterval(proxima, 2600);
    }

    function desliga() {
      if (relogio) { clearInterval(relogio); relogio = null; }
    }

    function paraDeVez() {
      parado = true;
      desliga();
    }

    Array.prototype.forEach.call(amostras, function (amostra, i) {
      amostra.addEventListener('click', function () {
        paraDeVez();
        atual = i;
        seleciona(i);
      });
      /* Teclado conta como escolha tambem: quem chegou na amostra pelo Tab
         esta decidindo, e a troca automatica atrapalharia a leitura. */
      amostra.addEventListener('focus', paraDeVez);
    });

    /* Os dois desligadores sao independentes — aba oculta e secao fora da
       tela — e por isso o estado da tela precisa ser lembrado. Sem `naTela`,
       voltar de outra aba religava o rodizio mesmo com a secao longe da vista,
       e o observador so voltaria a falar quando o limiar fosse cruzado de
       novo: ele giraria invisivel ate a pessoa sair da pagina. */
    var naTela = true;

    if (!parado && 'IntersectionObserver' in window) {
      naTela = false;
      new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          naTela = e.isIntersecting;
          naTela ? liga() : desliga();
        });
      }, { threshold: 0.25 }).observe(palco);
    } else {
      liga();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) desliga();
      else if (naTela) liga();
    });
  }

  /* ---------- a tinta que uma cor pede ----------
     A mesma conta que o quadro-vivo.liquid faz com o filtro color_contrast,
     refeita aqui porque a cor livre so existe depois que a pessoa digita o
     HEX: nao da para o Liquid saber dela.

     E a razao de contraste da WCAG, (L1 + 0.05) / (L2 + 0.05), medida contra
     branco e contra a tinta do tema. Ganha a maior. E ela que faz o verde
     #06E59C receber texto escuro — com branco daria 1,65:1, ilegivel — e o
     preto receber branco. Nenhuma cor que a pessoa escolher gera um quadro
     que nao da para ler. */

  function luminancia(hex) {
    var v = hex.replace('#', '');
    if (v.length === 3) v = v[0] + v[0] + v[1] + v[1] + v[2] + v[2];
    var canais = [0, 2, 4].map(function (i) {
      var c = parseInt(v.slice(i, i + 2), 16) / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * canais[0] + 0.7152 * canais[1] + 0.0722 * canais[2];
  }

  function contraste(a, b) {
    var la = luminancia(a);
    var lb = luminancia(b);
    var claro = Math.max(la, lb);
    var escuro = Math.min(la, lb);
    return (claro + 0.05) / (escuro + 0.05);
  }

  function tintaPara(hex) {
    return contraste(hex, '#FFFFFF') >= contraste(hex, '#1E1E1E') ? '#FFFFFF' : '#1E1E1E';
  }

  /* Repinta o quadro da cor livre: fundo, tinta do texto e do raio, e a
     assinatura, que tem duas versoes porque e imagem, nao texto. */
  function pintaQuadroLivre(hex) {
    var quadro = document.querySelector('[data-cf-quadro-livre]');
    if (!quadro) return;
    var tinta = tintaPara(hex);
    quadro.style.setProperty('--quadro-cor', hex);
    quadro.style.setProperty('--quadro-tinta', tinta);
    var logo = quadro.querySelector('[data-quadro-logo]');
    if (logo) {
      var fonte = tinta === '#FFFFFF' ? logo.getAttribute('data-clara') : logo.getAttribute('data-escura');
      if (fonte && logo.getAttribute('src') !== fonte) logo.setAttribute('src', fonte);
    }
  }

  /* ---------- previa da cor na pagina de produto ----------
     Sem JavaScript a primeira foto aparece e o <select> continua enviando a
     cor certa no pedido: a pessoa perde a previa, nao a escolha. */

  function iniciarPreviaCor() {
    var seletor = document.querySelector('[data-cf-cor]');
    var previa = document.querySelector('[data-cf-previa-cor]');
    if (!seletor || !previa) return;

    var fotos = previa.querySelectorAll('[data-previa]');
    if (!fotos.length) return;

    function pintar() {
      var i = String(seletor.selectedIndex);
      /* Nem toda opcao tem foto: a cor livre da marca nao tem, e a Juliana
         pode cadastrar uma cor sem imagem. Sem este recuo, NENHUMA foto ficava
         ativa e sobrava um vao branco do tamanho da maior foto. Cai na
         primeira, que e a neutra, e a nota ao lado explica o resto. */
      var existe = false;
      Array.prototype.forEach.call(fotos, function (f) {
        if (f.getAttribute('data-previa') === i) existe = true;
      });
      var alvo = existe ? i : '0';
      Array.prototype.forEach.call(fotos, function (f) {
        f.classList.toggle('esta-ativa', f.getAttribute('data-previa') === alvo);
      });
    }

    seletor.addEventListener('change', pintar);

    /* Uma vez no init, e nao so no change. O navegador restaura o valor do
       <select> ao voltar pelo historico ou ao dar refresh, mas NAO dispara
       change: a foto ficava na primeira cor enquanto o campo mostrava outra,
       e quem vai para o pedido e o campo. */
    pintar();
  }

  /* ---------- amostras de cor na pagina de produto ----------
     Camada por cima do <select>, que continua sendo o campo do formulario.
     As amostras nascem com `hidden` no HTML: sem JavaScript elas nem aparecem
     e o menu nativo continua funcionando. O pedido nunca depende disto.

     Aprovado pelo Elber em 28/08, junto com a amostra da cor livre. */

  function iniciarAmostrasProduto() {
    var grupo = document.querySelector('[data-cf-amostras]');
    var seletor = document.querySelector('[data-cf-cor]');
    if (!grupo || !seletor) return;

    var botoes = grupo.querySelectorAll('.amostra-cor');
    if (!botoes.length) return;

    var livre = grupo.querySelector('[data-cf-livre]');
    var painel = document.querySelector('[data-cf-painel-livre]');
    var roda = document.querySelector('[data-cf-roda]');
    var hex = document.querySelector('[data-cf-hex]');

    /* As amostras aparecem e o <select> sai de cena, mas continua no
       formulario: e ele que o /cart/add recebe. */
    grupo.hidden = false;
    seletor.classList.add('js-campo-oculto');

    var opcaoLivre = livre ? seletor.options[seletor.options.length - 1] : null;
    var rotuloLivre = opcaoLivre ? opcaoLivre.value : '';

    function marca(alvo) {
      Array.prototype.forEach.call(botoes, function (b) {
        b.setAttribute('aria-pressed', b === alvo ? 'true' : 'false');
      });
    }

    function valorLivre() {
      return rotuloLivre + ' (#' + hex.value.toUpperCase() + ')';
    }

    function escolhe(b) {
      marca(b);
      var eLivre = b.hasAttribute('data-cf-livre');

      if (painel) painel.hidden = !eLivre;
      /* Ate 28/08 havia aqui uma segunda nota, "esta cor nao tem foto pronta",
         que aparecia no lugar da primeira quando a cor livre era escolhida.
         Com o quadro montado em camadas a cor livre passou a ter previa como
         qualquer outra, e a nota deixou de ser verdade. */

      if (eLivre && opcaoLivre) {
        seletor.selectedIndex = seletor.options.length - 1;
        opcaoLivre.value = valorLivre();
      } else {
        seletor.selectedIndex = parseInt(b.getAttribute('data-indice'), 10) || 0;
      }
      /* `change` e o que faz a previa de cor repintar: ela escuta o select. */
      seletor.dispatchEvent(new Event('change'));
    }

    Array.prototype.forEach.call(botoes, function (b) {
      b.addEventListener('click', function () { escolhe(b); });
    });

    if (livre && roda && hex) {
      var pinta = function () {
        livre.style.setProperty('--cor-escolhida', roda.value);
        livre.classList.add('tem-cor');
        pintaQuadroLivre(roda.value);
        if (opcaoLivre && livre.getAttribute('aria-pressed') === 'true') {
          opcaoLivre.value = valorLivre();
        }
      };
      /* Uma vez no init, mas SO o quadro — nao `pinta()`.
         `pinta()` tambem poe `tem-cor` na amostra, o que troca o quadriculado
         com "+" por um circulo solido. Chamando pinta() aqui, a amostra da cor
         livre nascia azul e virava uma sexta cor pronta na fileira: some o
         convite de escolher a sua. A bolinha so ganha cor depois que a pessoa
         mexe. O quadro, esse sim, ja nasce na cor certa. */
      pintaQuadroLivre(roda.value);
      roda.addEventListener('input', function () {
        hex.value = roda.value.replace('#', '').toUpperCase();
        pinta();
      });
      hex.addEventListener('input', function () {
        var v = hex.value.replace(/[^0-9a-fA-F]/g, '').slice(0, 6);
        hex.value = v.toUpperCase();
        if (v.length === 6) { roda.value = '#' + v; pinta(); }
      });
    }

    marca(botoes[0]);
  }

  /* ---------- a saida pelo WhatsApp na pagina de produto ----------
     Quem chega aqui ja mexeu nas amostras de cor, na embalagem e na
     quantidade. Mandar so "quero um orcamento do Quadro" joga tudo isso fora,
     e a Juliana precisa perguntar de novo o que a pessoa acabou de responder.

     O href sai pronto do Liquid e continua valendo sem JavaScript: isto aqui
     so ACRESCENTA as escolhas. Reescrito no clique, e nao a cada mudanca de
     campo, porque o que importa e o estado no instante em que a pessoa sai. */

  function iniciarWhatsAppDoProduto() {
    /* TODOS os links, e nao so o primeiro (11/09).

       Era `querySelector`, no singular, e isso bastava enquanto havia um
       unico link de WhatsApp na pagina de produto. Desde que o modo rapido
       entrou, sao dois: o botao verde do formulario e o da barra fixa do
       celular. Com o singular, quem clicasse na barra fixa mandaria a
       mensagem SEM a quantidade escolhida — e a barra fixa e o botao do
       celular, que e de onde vem a maioria das visitas. */
    var links = document.querySelectorAll('[data-cf-wa-produto]');
    var form = document.querySelector('[data-cf-form-pedido]');
    if (!links.length || !form) return;

    Array.prototype.forEach.call(links, function (link) {
      var numero = link.getAttribute('data-wa-numero');
      var base = link.getAttribute('data-wa-base') || '';
      if (!numero) return;

      link.addEventListener('click', function () {
      var linhas = [base];
      var escolhas = [];

      /* Os campos do formulario sao os mesmos que vao no pedido: properties[].
         Ler daqui, e nao das amostras, garante que a mensagem diga o que o
         pedido diria — inclusive a cor livre, que chega como
         "A cor da minha marca (#FFE000)". */
      Array.prototype.forEach.call(
        form.querySelectorAll('[name^="properties"]'),
        function (campo) {
          /* Radio e checkbox tem valor mesmo desmarcados. Sem esta linha, o
             seletor de kit (31/08) mandaria os CINCO kits na mensagem e as
             quatro quantidades de card — o FormData do /cart/add filtra
             sozinho, este laco nao. */
          if ((campo.type === 'radio' || campo.type === 'checkbox') && !campo.checked) return;
          var valor = (campo.value || '').trim();
          if (!valor) return;
          var nome = campo.getAttribute('name').replace(/^properties\[/, '').replace(/\]$/, '');
          escolhas.push(nome + ': ' + valor);
        }
      );

      var qtd = form.querySelector('[name="quantity"]');
      if (qtd && qtd.value) escolhas.push('Quantidade: ' + qtd.value);

      /* 11/09: saiu o "Já escolhi:" e sairam os marcadores.

         A mensagem nao e um formulario preenchido, e a primeira frase de uma
         conversa. "Ja escolhi" soa a decisao fechada, e quem clica aqui ainda
         esta decidindo — o Elber pediu para nao dar a entender que abrir o
         WhatsApp prende a pessoa a alguma coisa.

         As escolhas viram uma linha so, coladas na saudacao, separadas por
         " - ". No WhatsApp isso le como quem esta dizendo o que quer, e nao
         como quem colou um pedido. */
      if (escolhas.length) {
        linhas.push(escolhas.join(' - '));
      }

      link.setAttribute(
        'href',
        'https://wa.me/' + numero + '?text=' + encodeURIComponent(linhas.join('\n'))
      );
      });
    });
  }

  /* ---------- fileira segmentada e atalhos de quantidade ----------
     Mesma ideia: o <select> e o <input> continuam sendo os campos do
     formulario; a camada nova so os opera. */

  function iniciarCamposDoPedido() {
    var form = document.querySelector('[data-cf-form-pedido]');
    if (!form) return;

    /* Um <select> de opcao com poucos valores vira fileira segmentada. Com
       muitos valores a fileira nao caberia, entao o nativo fica. */
    Array.prototype.forEach.call(form.querySelectorAll('select[name^="properties"]'), function (sel) {
      if (sel.hasAttribute('data-cf-cor')) return;
      if (sel.options.length < 2 || sel.options.length > 4) return;

      /* Os rotulos CURTOS decidem se a opcao vira fileira. O valor continua
         sendo o completo — "Bag de algodao, inclusa" precisa chegar inteiro na
         Juliana —, mas o botao mostra "Bag". Sem rotulos curtos no editor, ou
         com contagem diferente, o menu nativo do aparelho continua: e melhor
         um menu nativo do que tres botoes de tres linhas cada. */
      var curtos = (sel.getAttribute('data-cf-curtos') || '').split('|');
      if (curtos.length !== sel.options.length) return;

      var maior = 0;
      curtos.forEach(function (c) { maior = Math.max(maior, c.trim().length); });
      if (maior > 14) return;

      var fila = document.createElement('div');
      fila.className = 'seg-opcao';
      fila.setAttribute('role', 'group');

      var caixa = sel.closest('.campo');
      var rotulo = caixa ? caixa.querySelector('.campo__rotulo') : null;
      if (rotulo) {
        if (!rotulo.id) rotulo.id = 'rot-' + Math.random().toString(36).slice(2, 8);
        fila.setAttribute('aria-labelledby', rotulo.id);
      }

      Array.prototype.forEach.call(sel.options, function (op, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = curtos[i].trim();
        /* O botao mostra o curto, mas quem usa leitor de tela ouve o valor
           inteiro: e ele que vai no pedido. */
        b.setAttribute('aria-label', op.textContent.trim());
        b.setAttribute('aria-pressed', i === sel.selectedIndex ? 'true' : 'false');
        b.addEventListener('click', function () {
          sel.selectedIndex = i;
          Array.prototype.forEach.call(fila.children, function (o) {
            o.setAttribute('aria-pressed', o === b ? 'true' : 'false');
          });
          sel.dispatchEvent(new Event('change'));
        });
        fila.appendChild(b);
      });

      sel.parentNode.insertBefore(fila, sel);
      sel.classList.add('js-campo-oculto');
    });

    /* Atalhos de quantidade: as faixas que a copy aprovada pedia, por cima de
       um campo numerico que continua sendo o valor real. Faixa nao e numero, e
       o carrinho precisa de inteiro para o medidor de minimo e para o
       "Total: N unidades" da mensagem do WhatsApp. */
    var campo = form.querySelector('input[name="quantity"]');
    if (!campo) return;

    var minimo = parseInt(campo.getAttribute('min'), 10) || 30;
    /* O passo dos botoes e 10, e nao o `step` do campo. O step precisa ser 1
       para a pessoa poder digitar 137 sem o navegador reclamar; mas num pedido
       que comeca em 30 unidades, um botao que anda de 1 em 1 e inutil — sao
       sete toques para sair de 30 e chegar em 37. Digitar continua livre. */
    var passo = 10;

    /* O − e o + do desenho aprovado. O <input> continua sendo o campo: os
       botoes so escrevem nele e disparam os mesmos eventos que a digitacao,
       para o medidor do pedido e os atalhos acompanharem. Sem JavaScript o
       campo numerico fica como esta hoje. */
    var trilho = document.createElement('div');
    trilho.className = 'qtd__passo';

    function botao(sinal, delta, rotulo) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = sinal;
      b.setAttribute('aria-label', rotulo);
      b.addEventListener('click', function () {
        var atual = parseInt(campo.value, 10) || minimo;
        campo.value = String(Math.max(minimo, atual + delta));
        campo.dispatchEvent(new Event('input'));
        campo.dispatchEvent(new Event('change'));
      });
      return b;
    }

    campo.parentNode.insertBefore(trilho, campo);
    trilho.appendChild(botao('\u2212', -passo, 'Diminuir quantidade'));
    trilho.appendChild(campo);
    trilho.appendChild(botao('+', passo, 'Aumentar quantidade'));
    campo.classList.add('qtd__campo');
    /* Os degraus vem do editor, com o padrao 30|100|300|500 — exatamente as
       faixas da copy aprovada. Multiplicar o minimo dava numeros feios (90,
       510) e nao era o que estava escrito. Qualquer valor abaixo do minimo e
       descartado, para o atalho nunca oferecer um pedido que a producao
       recusa. */
    var cfg = window.CF_PEDIDO || {};
    var degraus = String(cfg.faixasQtd || '30|100|300|500|1000|3000|5000').split('|');
    var vistos = {};
    var faixas = document.createElement('div');
    faixas.className = 'faixas-qtd';
    faixas.setAttribute('role', 'group');
    faixas.setAttribute('aria-label', 'Quantidades mais pedidas');

    degraus.forEach(function (bruto) {
      var n = parseInt(bruto, 10);
      if (!n || n < minimo || vistos[n]) return;
      vistos[n] = true;
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = String(n);
      b.addEventListener('click', function () {
        campo.value = String(n);
        campo.dispatchEvent(new Event('input'));
        campo.dispatchEvent(new Event('change'));
      });
      faixas.appendChild(b);
    });

    /* O ultimo degrau da lista dela e "acima", que nao e numero — e o campo
       precisa de inteiro. Ele leva ao topo da tabela e diz, em nota, que o
       volume exato se fecha na conversa. E deliberado nao travar aqui: a
       pessoa pode sair daqui com 5000 e combinar 8000 com a Juliana, e uma
       pergunta a mais neste ponto desqualifica lead em vez de qualificar. */
    var topo = 0;
    Object.keys(vistos).forEach(function (n) { topo = Math.max(topo, parseInt(n, 10)); });

    var nota = document.createElement('p');
    nota.className = 'faixas-qtd__nota';
    nota.hidden = true;
    nota.setAttribute('role', 'status');
    nota.textContent = 'Acima de ' + topo.toLocaleString('pt-BR') +
      ' a gente fecha o volume junto, no WhatsApp.';

    if (topo) {
      var acima = document.createElement('button');
      acima.type = 'button';
      acima.setAttribute('data-acima', '');
      acima.textContent = 'Acima';
      acima.addEventListener('click', function () {
        campo.value = String(topo);
        campo.dispatchEvent(new Event('input'));
        campo.dispatchEvent(new Event('change'));
        nota.hidden = false;
      });
      faixas.appendChild(acima);
    }

    function pintaFaixas() {
      Array.prototype.forEach.call(faixas.children, function (b) {
        /* O "Acima" nao tem numero para comparar: quem o acende e o clique. */
        if (b.hasAttribute('data-acima')) return;
        var marcado = b.textContent === campo.value;
        b.setAttribute('aria-pressed', marcado ? 'true' : 'false');
        if (marcado) nota.hidden = true;
      });
    }

    /* Desde 01/09 o campo aceita digitar abaixo do minimo. Quem digita 25 nao
       pode ficar sem resposta: ele veria a ajuda dizendo "minimo 30" e nada
       acontecendo, e concluiria que o site nao aceita o pedido dele — que e
       exatamente o lead que se queria manter. A nota diz, na linguagem que a
       gaveta ja usa, que abaixo do minimo se resolve na conversa.

       Nao bloqueia nada: e status, nao erro. E some sozinha quando o valor
       volta para dentro da faixa.

       O dono da nota fica marcado porque ela e compartilhada com o "Acima".
       Sem isso, digitar 25 e depois 250 deixava a nota no ar com o texto
       velho: o pintaFaixas so a esconde quando o valor bate numa pilula, e
       250 nao bate em nenhuma. */
    function notaAbaixo() {
      var v = parseInt(campo.value, 10);
      if (v && v < minimo) {
        nota.textContent = 'Abaixo de ' + minimo + ' a gente vê o que dá para fazer. ' +
          'Peça assim mesmo e a Juliana responde no WhatsApp.';
        nota.dataset.dono = 'abaixo';
        nota.hidden = false;
        return;
      }
      if (nota.dataset.dono === 'abaixo') {
        nota.hidden = true;
        delete nota.dataset.dono;
      }
    }

    campo.addEventListener('input', function () {
      pintaFaixas();
      notaAbaixo();
    });
    trilho.parentNode.insertBefore(faixas, trilho.nextSibling);
    faixas.parentNode.insertBefore(nota, faixas.nextSibling);
    pintaFaixas();
  }

  /* ---------- menu do celular ----------
     O <details> ja abre, fecha e opera pelo teclado sozinho, e desde 28/08 o
     proprio <summary> vira o X do painel — entao fechar tambem funciona sem
     JavaScript. O JS so acrescenta o que o elemento nativo nao da: fechar com
     Esc, fechar ao seguir um link, e fechar ao passar dos 900px. */

  function iniciarMenu() {
    var menu = document.querySelector('[data-menu-movel]');
    if (!menu) return;

    /* O "clicar fora fecha" saiu em 28/08. O painel passou a cobrir a tela
       inteira: nao existe mais um "fora" para clicar, e a regra so criava o
       risco de fechar o menu num toque que a pessoa deu para rolar. Quem
       fecha e o X — que e o proprio <summary>, entao funciona sem JS. */

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !menu.open) return;
      menu.open = false;
      var botao = menu.querySelector('summary');
      if (botao) botao.focus();
    });

    /* Acima de 900px o <details> some por CSS, mas continua `open` — e a trava
       de rolagem no <html> ficava presa com o menu invisivel e sem X para
       fechar. Abrir no celular e girar para paisagem travava a pagina. */
    var soCelular = window.matchMedia('(max-width: 899px)');
    var aoTrocarLargura = function () { if (!soCelular.matches) menu.open = false; };
    if (soCelular.addEventListener) soCelular.addEventListener('change', aoTrocarLargura);
    else if (soCelular.addListener) soCelular.addListener(aoTrocarLargura);

    /* Ao seguir um link o menu fica aberto por tras da pagina nova quando o
       destino e uma ancora da mesma pagina. */
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) menu.open = false;
    });

    var gatilho = menu.querySelector('summary');

    menu.addEventListener('toggle', function () {
      if (menu.open && gatilho) {
        /* O circulo precisa nascer no proprio botao, e a posicao dele depende
           da gutter (que e clamp), da faixa estar recolhida ou nao, e de a
           faixa existir — a Juliana pode remover a secao. Coordenada fixa
           errava por 11px parado e por 39px depois de rolar: o menu abria de
           um ponto no meio do nada. Medir e a unica forma de acertar sempre.

           A leitura acontece antes de o CSS tornar o summary `fixed`, porque
           o navegador ainda nao recalculou o estilo neste ponto do toggle. */
        var r = gatilho.getBoundingClientRect();
        menu.style.setProperty('--org-x', Math.round(r.left + r.width / 2) + 'px');
        menu.style.setProperty('--org-y', Math.round(r.top + r.height / 2) + 'px');
      }

      /* Painel opaco de tela cheia: sem isto o Tab atravessa para a logo, para
         o botao de orcamento e para a pagina inteira ATRAS do painel, e o
         leitor de tela le tudo. `overflow: hidden` nao torna nada nao-focavel. */
      var barra = menu.parentElement;
      Array.prototype.forEach.call(
        document.querySelectorAll('main, .barra-fixa, .whatsapp-flutuante'),
        function (el) {
          /* Na landing page o cabecalho e secao do template, e portanto mora
             DENTRO do <main>. Tornar o <main> inerte travaria o proprio menu,
             sem X para fechar. Ali a trava desce um nivel: vale para cada
             secao do <main>, menos a que contem o menu. */
          if (el.contains(menu)) {
            Array.prototype.forEach.call(el.children, function (filho) {
              if (!filho.contains(menu)) filho.inert = menu.open;
            });
            return;
          }
          el.inert = menu.open;
        }
      );
      if (barra) {
        Array.prototype.forEach.call(barra.children, function (el) {
          if (el !== menu) el.inert = menu.open;
        });
      }
    });
  }

  /* ---------- a faixa recolhe ao rolar ----------
     A classe vai no <html> porque a faixa e o cabecalho sao secoes irmas: nao
     ha um ancestral comum mais proximo que as duas.

     Histerese de 10px para descer e 4px para voltar: com um limiar unico, uma
     rolagem parada exatamente em cima dele faz a faixa piscar. Sem JavaScript
     a faixa simplesmente fica sempre visivel, que e o estado de hoje. */

  function iniciarFaixaQueRecolhe() {
    var faixa = document.querySelector('.faixa');
    if (!faixa) return;

    var raiz = document.documentElement;
    var pedido = null;

    function mede() {
      pedido = null;
      var y = window.pageYOffset;
      /* Recolher a faixa tira ~43px da altura do documento com a posicao de
         rolagem mantida, entao o conteudo salta para cima. Com limiar de 10px
         o salto devolvia a pagina para dentro da faixa de desligar, e a faixa
         piscava. Descer so depois de passar a propria altura dela. */
      if (y > 60) raiz.classList.add('rolou');
      else if (y < 8) raiz.classList.remove('rolou');
    }

    window.addEventListener('scroll', function () {
      if (!pedido) pedido = window.requestAnimationFrame(mede);
    }, { passive: true });

    mede();
  }

  /* ---------- galeria da pagina de produto ----------
     Foto principal com tira de miniaturas. Sem JavaScript as miniaturas nao
     fazem nada e a primeira foto aparece normalmente: a pessoa perde a troca,
     nao a pagina. */

  function iniciarGaleria() {
    var galeria = document.querySelector('[data-galeria]');
    if (!galeria) return;

    var fotos = galeria.querySelectorAll('[data-galeria-foto]');
    var tiras = galeria.querySelectorAll('[data-galeria-tira]');
    if (fotos.length < 2 || !tiras.length) return;

    /* A tira virou carrossel em 09/09: as miniaturas rolam de lado, com 30%
       da quinta aparecendo na borda. Quem escolhe pela seta do teclado sai
       da faixa visivel a partir da quinta foto, entao a faixa anda atras da
       escolha.

       Sem `scrollIntoView`: `block: 'nearest'` ainda pode rolar a PAGINA
       quando a galeria esta parcialmente fora da tela, e aqui so a faixa
       deve andar. Dois `getBoundingClientRect` resolvem sem tocar na pagina.

       So mexe quando a miniatura esta cortada: nudge a cada clique faria a
       faixa pular sozinha em toda escolha, inclusive nas que ja estao a
       vista. */
    function trazerParaVista(t) {
      var faixa = t.parentNode;
      if (!faixa || faixa.scrollWidth <= faixa.clientWidth + 1) return;

      var alvo = t.getBoundingClientRect();
      var vista = faixa.getBoundingClientRect();
      var folga = 12;
      var passo = 0;

      if (alvo.left < vista.left) passo = alvo.left - vista.left - folga;
      else if (alvo.right > vista.right) passo = alvo.right - vista.right + folga;
      if (!passo) return;

      var suave = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (faixa.scrollBy) faixa.scrollBy({ left: passo, behavior: suave ? 'smooth' : 'auto' });
      else faixa.scrollLeft += passo;
    }

    function mostrar(i) {
      Array.prototype.forEach.call(fotos, function (f) {
        f.classList.toggle('esta-ativa', f.getAttribute('data-galeria-foto') === i);
      });
      Array.prototype.forEach.call(tiras, function (t) {
        var esta = t.getAttribute('data-galeria-tira') === i;
        t.setAttribute('aria-pressed', esta ? 'true' : 'false');
        if (esta) trazerParaVista(t);
      });
    }

    Array.prototype.forEach.call(tiras, function (t) {
      t.addEventListener('click', function () {
        mostrar(t.getAttribute('data-galeria-tira'));
      });
    });

    /* Setas para navegar entre as miniaturas, que e o que se espera de um
       grupo de botoes que representa uma escolha. */
    galeria.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var atual = Array.prototype.indexOf.call(tiras, document.activeElement);
      if (atual < 0) return;
      e.preventDefault();
      var proximo = (atual + (e.key === 'ArrowRight' ? 1 : -1) + tiras.length) % tiras.length;
      tiras[proximo].focus();
      mostrar(tiras[proximo].getAttribute('data-galeria-tira'));
    });
  }

  /* ---------- anatomia: o ponto responde ----------
     Um item aberto por vez. O ponto no circulo e o rotulo na coluna sao duas
     portas para a mesma coisa, entao os dois carregam o mesmo data-anat e o
     estado vive no par, nao no elemento clicado.

     Hover so pre-visualiza; clique prende. Sem isso, no desktop, a informacao
     sumiria no instante em que a pessoa move o mouse para ler. */

  function iniciarAnatomia() {
    var secao = document.querySelector('.anatomia-viva');
    if (!secao) return;

    var marcas = secao.querySelectorAll('.anatomia__marca[data-anat]');
    var specs = secao.querySelectorAll('.spec[data-anat]');
    if (!marcas.length && !specs.length) return;

    var presa = null;
    var previa = null;

    /* ---------- as fotos da lupa chegam antes do dedo ----------
       Como background-image, cada foto so era buscada no primeiro hover: a
       lente abria vazia e a imagem aparecia depois. Um preload no <head>
       resolveria o atraso e criaria outro pior — cinco fotos macro
       competindo com a foto principal no carregamento da pagina, que e o
       que a pessoa realmente ve primeiro.

       O meio-termo e buscar quando a secao entra na tela: nesse momento a
       pagina ja carregou o que importa, e ainda faltam varios segundos de
       rolagem ate alguem passar o mouse. As imagens ficam no cache do
       navegador, e e de la que o background-image as pega depois.

       Sem IntersectionObserver (navegador antigo), busca na hora e pronto:
       o custo e o mesmo de antes, so adiantado. */
    function aquecerLupas() {
      Array.prototype.forEach.call(secao.querySelectorAll('.spec[data-lupa]'), function (s) {
        var url = s.getAttribute('data-lupa');
        if (!url) return;
        var img = new Image();
        img.decoding = 'async';
        img.src = url;
      });
    }
    if ('IntersectionObserver' in window) {
      var vigia = new IntersectionObserver(function (entradas) {
        if (!entradas.some(function (e) { return e.isIntersecting; })) return;
        vigia.disconnect();
        aquecerLupas();
      }, { rootMargin: '300px' });
      vigia.observe(secao);
    } else {
      aquecerLupas();
    }

    /* ---------- a lupa ----------
       Uma bolinha com a mesma foto ampliada por tras. Para o trecho certo
       aparecer, a conta e ao contrario: o ponto (px, py) da foto AMPLIADA
       precisa cair no centro da lente, entao o fundo anda
       -(ponto x zoom) + metade da lente.

       As coordenadas sao % DA FOTO, nao do palco: a foto ocupa 52% ou 73%
       do palco conforme a largura, e ancorar no palco faria o mesmo ajuste
       da Juliana apontar para lugares diferentes em cada tela. */
    var lente = secao.querySelector('[data-cf-lente]');
    var foto = secao.querySelector('.anatomia__figura img');
    var palco = secao.querySelector('.anatomia__palco');
    var ZOOM = 2.4;

    function moveLente(alvo) {
      if (!lente || !foto || !palco) return;
      var spec = alvo && secao.querySelector('.spec[data-anat="' + alvo + '"]');
      var foco = spec && spec.getAttribute('data-foco');
      if (!foco) { lente.classList.remove('esta-viva'); return; }

      var partes = foco.split(',');
      var px = parseFloat(partes[0]) / 100;
      var py = parseFloat(partes[1]) / 100;
      if (isNaN(px) || isNaN(py)) { lente.classList.remove('esta-viva'); return; }

      var rf = foto.getBoundingClientRect();
      var rp = palco.getBoundingClientRect();
      if (!rf.width) { lente.classList.remove('esta-viva'); return; }

      var lw = lente.offsetWidth, lh = lente.offsetHeight;
      /* do canto da foto para o canto do palco, que e quem posiciona */
      var x = (rf.left - rp.left) + px * rf.width;
      var y = (rf.top - rp.top) + py * rf.height;

      lente.style.left = (x - lw / 2) + 'px';
      lente.style.top = (y - lh / 2) + 'px';

      /* Duas lentes na mesma bolinha.

         Com data-lupa o item tem foto macro propria, e ela preenche a lente
         inteira. Foi para isso que as cinco fotos de detalhe foram tiradas:
         ampliar a foto do quadro so revela o que a resolucao dela guarda, e
         nenhuma foto de produto guarda o gramado do papel, a emenda da
         moldura ou a serigrafia da bag. A foto macro guarda.

         Sem data-lupa segue a conta antiga, que amplia o trecho da foto
         principal. O data-foco manda nos dois casos, mas so sobre ONDE a
         lente aparece — a foto muda O QUE ela mostra. */
      var lupa = spec.getAttribute('data-lupa');
      if (lupa) {
        lente.style.backgroundImage = 'url("' + lupa + '")';
        lente.style.backgroundSize = 'cover';
        lente.style.backgroundPosition = 'center';
      } else {
        lente.style.backgroundImage = 'url("' + foto.currentSrc + '")';
        lente.style.backgroundSize = (rf.width * ZOOM) + 'px ' + (rf.height * ZOOM) + 'px';
        lente.style.backgroundPosition =
          (-(px * rf.width * ZOOM) + lw / 2) + 'px ' +
          (-(py * rf.height * ZOOM) + lh / 2) + 'px';
      }
      lente.classList.add('esta-viva');
    }

    function pinta() {
      var alvo = presa || previa;
      moveLente(alvo);

      Array.prototype.forEach.call(marcas, function (m) {
        var ligado = m.getAttribute('data-anat') === alvo;
        m.classList.toggle('esta-ativa', ligado);
        if (ligado) m.classList.add('foi-vista');
        var botao = m.querySelector('.anatomia__ponto');
        if (botao && botao.tagName === 'BUTTON') {
          botao.setAttribute('aria-expanded', ligado ? 'true' : 'false');
        }
      });

      Array.prototype.forEach.call(specs, function (s) {
        var ligado = s.getAttribute('data-anat') === alvo;
        s.classList.toggle('esta-aberta', ligado);
        var botao = s.querySelector('button.spec__rotulo');
        if (botao) botao.setAttribute('aria-expanded', ligado ? 'true' : 'false');
      });
    }

    function prende(i) {
      presa = (presa === i) ? null : i;
      previa = null;
      pinta();
    }

    Array.prototype.forEach.call(secao.querySelectorAll('[data-anat]'), function (el) {
      var i = el.getAttribute('data-anat');
      var botao = el.querySelector('button.anatomia__ponto, button.spec__rotulo');
      if (!botao) return;

      botao.addEventListener('click', function (e) {
        e.stopPropagation();
        prende(i);
      });
      el.addEventListener('mouseenter', function () {
        if (!presa) { previa = i; pinta(); }
      });
      el.addEventListener('mouseleave', function () {
        if (previa) { previa = null; pinta(); }
      });
      botao.addEventListener('focus', function () {
        if (!presa) { previa = i; pinta(); }
      });
      botao.addEventListener('blur', function () {
        if (previa) { previa = null; pinta(); }
      });
    });

    /* ---------- o hover que o celular nao tem ----------
       No desktop cada informacao abre ao passar o mouse. No celular nao existe
       passar o mouse, e o rotulo vira a unica porta — que a pessoa precisa
       descobrir. A pedido do Elber em 28/08, quem faz o papel do mouse ali e a
       propria rolagem: a informacao que esta na linha de leitura abre sozinha,
       uma de cada vez, e fecha quando a proxima chega.

       Continua sendo o mesmo mecanismo de `previa` do desktop, entao um clique
       (que define `presa`) desliga isto sem nenhum caso especial: `pinta()` ja
       da preferencia ao que foi preso, e `previa` para de ser consultado.

       So no celular: acima de 1040px a composicao radial existe e o mouse
       resolve. */
    var rolagemAbre = window.matchMedia('(max-width: 1039px)');

    if (specs.length && !paraMovimento) {
      var pedido = null;
      var ultimoY = window.pageYOffset;
      var velocidade = 0;

      function daLinhaDeLeitura() {
        /* A linha de leitura fica a 45% da altura da tela: e onde o olho
           descansa ao rolar, um pouco acima do centro. Abre a informacao cujo
           texto cruza essa linha. */
        var linha = window.innerHeight * 0.45;
        var escolhida = null;
        var menor = Infinity;

        Array.prototype.forEach.call(specs, function (s) {
          var r = s.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          var d = Math.abs(r.top + r.height / 2 - linha);
          /* Meia tela de tolerancia: fora disso nada abre, para a secao nao
             ficar com uma informacao presa aberta quando a pessoa ja saiu. */
          if (d < menor && d < window.innerHeight * 0.5) { menor = d; escolhida = s; }
        });

        return escolhida ? escolhida.getAttribute('data-anat') : null;
      }

      var pousa = null;

      function aplica() {
        if (!rolagemAbre.matches || presa) return;
        var alvo = daLinhaDeLeitura();
        if (alvo !== previa) { previa = alvo; pinta(); }
      }

      function aoRolar() {
        var y = window.pageYOffset;
        velocidade = Math.abs(y - ultimoY);
        ultimoY = y;

        /* Duas passadas, e as duas importam.

           A de agora, no proximo quadro, e a que faz a informacao acompanhar o
           dedo. Ela e pulada quando a rolagem esta rapida — acima de 90px por
           quadro a pessoa esta procurando outra coisa, nao lendo, e abrir e
           fechar seis baloes durante um deslize vira piscada.

           A do fim, 140ms depois que a rolagem para, e a que garante o acerto.
           Sem ela, uma rolagem que TERMINA em movimento rapido deixava a secao
           com a informacao errada aberta, porque a ultima passada boa tinha
           sido descartada pelo guarda de velocidade. */
        if (!pedido) {
          pedido = window.requestAnimationFrame(function () {
            pedido = null;
            if (velocidade > 90) return;
            aplica();
          });
        }

        if (pousa) clearTimeout(pousa);
        pousa = setTimeout(aplica, 140);
      }

      window.addEventListener('scroll', aoRolar, { passive: true });

      /* Uma vez ao entrar, para quem abre a pagina ja na altura da secao —
         mas depois dos 600ms da animacao de entrada. `.spec` esta na lista de
         alvos de iniciarReveal, e `.revela` aplica translateY(14px): medir
         durante a transicao le cada item 14px abaixo do lugar real, e a
         primeira escolha podia cair no vizinho. */
      setTimeout(aplica, 650);
    }

    /* Cada bolinha sobe ou desce ate a altura do proprio texto, continuando em
       cima do circulo. Sem isto o traco de ligacao aponta para o vazio: o
       angulo fixo do desenho e a altura que a coluna deu podem estar a 55px de
       distancia.

       Para uma altura dy em relacao ao centro, o ponto do circulo naquela
       altura esta em x = +-raiz(r^2 - dy^2). O limite de 0,94 do raio evita
       que um texto muito no alto ou muito embaixo empurre a bolinha para o
       topo exato do circulo, onde ela encostaria na vizinha.

       Se o JS nao rodar, valem os angulos do CSS, que ja vem do desenho. */
    var palco = secao.querySelector('.anatomia__palco');
    var TRACO_Y = 9; // igual ao --traco-y do CSS

    function alinha() {
      if (!palco || !marcas.length) return;
      if (window.matchMedia('(max-width: 1039px)').matches) return;

      var rp = palco.getBoundingClientRect();
      if (!rp.width) return;
      var raio = rp.width / 2;
      var centroY = rp.top + rp.height / 2;

      Array.prototype.forEach.call(marcas, function (m) {
        var spec = secao.querySelector('.spec[data-anat="' + m.getAttribute('data-anat') + '"]');
        if (!spec) return;

        var dy = spec.getBoundingClientRect().top + TRACO_Y - centroY;
        var limite = raio * 0.94;
        if (dy > limite) dy = limite;
        if (dy < -limite) dy = -limite;

        var dx = Math.sqrt(Math.max(raio * raio - dy * dy, 0));
        if (m.getAttribute('data-lado') === 'esq') dx = -dx;

        m.style.setProperty('--ang', (Math.atan2(dy, dx) * 180 / Math.PI).toFixed(2) + 'deg');

        /* O traco tambem precisa do comprimento certo. Com tamanho fixo, os
           pontos mais altos ficavam a 200px do fim do traco e a ligacao virava
           um risco solto ao lado do texto. Agora ele vai do texto ate 8px
           antes da bolinha, qualquer que seja a altura dela. */
        var rp2 = m.querySelector('.anatomia__ponto').getBoundingClientRect();
        var rs2 = spec.getBoundingClientRect();
        var comprimento = (m.getAttribute('data-lado') === 'esq')
          ? rp2.left - rs2.right - 6
          : rs2.left - rp2.right - 6;
        spec.style.setProperty('--traco', Math.max(Math.round(comprimento), 20) + 'px');
      });
    }

    alinha();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(alinha);

    var relogio = null;
    window.addEventListener('resize', function () {
      clearTimeout(relogio);
      relogio = setTimeout(alinha, 120);
    });

    document.addEventListener('click', function (e) {
      if (!presa) return;
      /* No celular a escolha vale ate a pessoa sair da secao. Este handler foi
         escrito para o desktop, onde clicar fora fecha o balao; com a rolagem
         virando um segundo autor de estado, um toque para frear a inercia ou
         no vao entre dois itens devolvia o comando a rolagem sem aviso. */
      if (rolagemAbre.matches && secao.contains(e.target)) return;
      presa = null;
      pinta();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !presa) return;
      var marca = secao.querySelector('.anatomia__marca[data-anat="' + presa + '"] button.anatomia__ponto');
      presa = null;
      pinta();
      if (marca) marca.focus();
    });
  }

  /* ---------- card do hero: troca frase, cor e cliente ----------
     É o produto se demonstrando. Cada volta mostra a mesma moldura com a cara
     de outro cliente. Para quando a aba perde o foco, para não girar à toa. */

  function iniciarCarrossel() {
    var cartao = document.querySelector('[data-cartao]');
    var ciclo = document.querySelector('[data-ciclo]');
    if (!cartao || !ciclo || paraMovimento) return;

    var slides = Array.prototype.slice.call(ciclo.querySelectorAll('[data-slide]'));
    if (!slides.length) return;

    var alvoFrase = cartao.querySelector('[data-cartao-frase]');
    var alvoCliente = cartao.querySelector('[data-cartao-cliente]');
    var i = 0;
    var relogio = null;

    function pintar(s) {
      cartao.style.background = s.dataset.fundo;
      cartao.style.color = s.dataset.texto;
      if (alvoFrase) alvoFrase.textContent = s.dataset.frase;
      if (alvoCliente) alvoCliente.textContent = s.dataset.cliente;
    }

    function girar() {
      i = (i + 1) % slides.length;
      cartao.dataset.trocando = 'true';
      window.setTimeout(function () {
        pintar(slides[i]);
        cartao.dataset.trocando = 'false';
      }, 240);
    }

    function ligar() {
      if (!relogio) relogio = window.setInterval(girar, 3600);
    }

    function desligar() {
      if (relogio) {
        window.clearInterval(relogio);
        relogio = null;
      }
    }

    ligar();
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) desligar();
      else ligar();
    });
  }

  /* ---------- reveal discreto no scroll ---------- */

  function iniciarReveal() {
    var alvos = document.querySelectorAll('.card-produto, .depoimento, .frase-cartao, .spec');
    if (!alvos.length) return;

    if (paraMovimento || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(alvos, function (el) {
        el.classList.add('revela', 'dentro');
      });
      return;
    }

    Array.prototype.forEach.call(alvos, function (el) {
      el.classList.add('revela');
    });

    var olho = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('dentro');
            olho.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    Array.prototype.forEach.call(alvos, function (el) {
      olho.observe(el);
    });
  }

  /* ---------- indice do documento longo ----------
     Le os <h2> do conteudo, cria as ancoras e monta a lista. A Juliana edita o
     texto no admin e o indice se refaz sozinho: indice mantido a mao fica
     errado no terceiro paragrafo novo.

     Sem JavaScript o indice nao aparece e o texto continua inteiro. E enfeite
     de navegacao, nao conteudo. */

  function iniciarIndice() {
    var doc = document.querySelector('[data-cf-documento]');
    var nav = document.querySelector('[data-cf-indice]');
    var lista = document.querySelector('[data-cf-indice-lista]');
    if (!doc || !nav || !lista) return;

    var titulos = doc.querySelectorAll('h2');
    if (titulos.length < 2) return; // com um titulo so, indice nao ajuda ninguem

    var itens = [];
    Array.prototype.forEach.call(titulos, function (h, i) {
      if (!h.id) {
        var base = (h.textContent || 'secao')
          .normalize('NFD').replace(/[̀-ͯ]/g, '')
          .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
        h.id = base ? base : 'secao-' + (i + 1);
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      lista.appendChild(li);
      itens.push({ titulo: h, link: a });
    });

    nav.hidden = false;

    if (!('IntersectionObserver' in window)) {
      itens[0].link.setAttribute('aria-current', 'true');
      return;
    }

    /* Marca o titulo mais alto que ja passou do topo. rootMargin negativo em
       cima faz o destaque trocar quando o titulo encosta no topo, e nao quando
       ele entra na tela pelo rodape. */
    var visiveis = new Set();
    var olho = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) visiveis.add(e.target);
        else visiveis.delete(e.target);
      });

      var ativo = null;
      for (var i = 0; i < itens.length; i++) {
        if (visiveis.has(itens[i].titulo)) { ativo = itens[i]; break; }
      }
      if (!ativo) return;

      itens.forEach(function (it) {
        if (it === ativo) it.link.setAttribute('aria-current', 'true');
        else it.link.removeAttribute('aria-current');
      });
    }, { rootMargin: '-12% 0px -70% 0px', threshold: 0 });

    itens.forEach(function (it) { olho.observe(it.titulo); });
  }

  /* ---------- contador da pagina do carrinho ----------
     A pagina /cart funciona por formulario, para sobreviver sem JavaScript.
     Com JavaScript, os passos de mais e menos aparecem e submetem o form:
     mesma mecanica, menos digitacao. */

  function iniciarContadorPagina() {
    var passos = document.querySelectorAll('[data-cf-passo]');
    if (!passos.length) return;

    Array.prototype.forEach.call(passos, function (b) {
      b.hidden = false;
      b.addEventListener('click', function () {
        var caixa = b.closest('.contador');
        var campo = caixa && caixa.querySelector('input[type="number"]');
        if (!campo) return;

        var valor = parseInt(campo.value, 10);
        if (isNaN(valor)) valor = 0;
        valor += parseInt(b.getAttribute('data-cf-passo'), 10);
        if (valor < 0) valor = 0;

        campo.value = valor;
        var form = campo.closest('form');
        if (form) form.submit();
      });
    });
  }

  function iniciar() {
    iniciarIndice();
    iniciarContadorPagina();
    iniciarAmostras();
    iniciarAnatomia();
    iniciarGaleria();
    iniciarMenu();
    iniciarFaixaQueRecolhe();
    iniciarPreviaCor();
    iniciarAmostrasProduto();
    iniciarCamposDoPedido();
    iniciarWhatsAppDoProduto();
    iniciarCarrossel();
    iniciarReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* O editor de tema recria seções sem recarregar a página. Sem isto, uma
     seção editada perde o comportamento até o próximo refresh. */
  document.addEventListener('shopify:section:load', iniciar);
})();
